/*
 * @Author: 张志明
 * @Date: 2021-09-01 14:24:08
 * @LastEditTime: 2022-11-16 17:04:55
 * @Description:
 */
import axiosObj from './axios';
const ajax = axiosObj.ajax;
import axios from 'axios';
import dayjs from 'dayjs';
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
import md5 from 'md5';
import { uuid } from './utils';
export const toAliOss = async (data, vm) => {
    let appkey = vm.$store ? vm.$store.state.info.memberInfo.Appkey : '';
    const appkeys = [8957728, 9314196, 2721863]; // 就这个几个appkey 不走代理
    if (!appkey) {
        appkey = await new Promise((resolve) => {
            ajax.post('app/auth/getmemberInfo', {}).then((res) => {
                resolve(res.Appkey);
            });
        });
    }
    let options = {
        fileName: `${uuid()}.txt`,
        contentType: 'text/plain; charset=UTF-8',
        ajaxData: '',
        IsAgent: !appkeys.includes(parseInt(appkey)),
    };
    options = Object.assign(options, data);
    return new Promise((resolve) => {
        ajax.post('app/api/oss/generatesigneduploadurl', {
            fileName: options.fileName,
            contentType: options.contentType,
            IsAgent: options.IsAgent,
        })
            .then((res) => {
                if (res.code != 200) {
                    this.$message.warning(res.msg || '上传失败，请稍后重试');
                    resolve(false);
                    return;
                }
                axios
                    .put(res.result, options.ajaxData, {
                        headers: {
                            'Content-Type': options.contentType,
                        },
                    })
                    .then((data) => {
                        if (data.status != 200) {
                            resolve(false);
                            return;
                        }
                        resolve(res.result.split('?')[0]);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            })
            .catch(() => {
                resolve(false);
            });
    });
};

export const handleGaoDingFiles = (files, albumId) => {
    const date = new Date();
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month <= 9) {
        month = '0' + month;
    }
    let day = date.getDate();
    if (day <= 9) {
        day = '0' + day;
    }
    const imgName = '图片编辑' + year + '' + month + '' + day + Math.random() * 10000;
    var filedata = new window.File([files[0]], imgName, { type: files[0].type });

    const formData = new FormData();
    formData.append('filedata', filedata);
    formData.append('alialbumId', albumId || '');
    formData.append('Tag', '大泽装修图片保存到阿里相册');

    return formData;
};
/**
 * @description: 加密
 * @param {Object|String} options 各个接口的入参
 * @return {String} rc 前端生成一个随机码
 * @return {Number} rd UTC时间戳到秒
 * @return {String} rs 通过规则 生成sign
 */
export const encryption = (options) => {
    const rc = uuid();
    const rd = dayjs.utc().unix();
    const p = md5(options);
    const rs = md5(`${rc}|${p}*${rd}`);
    return { rc, rs, rd };
};
export default {
    handleGaoDingFiles,
    toAliOss,
    encryption,
};
